import { render, staticRenderFns } from "./Exhibitions.vue?vue&type=template&id=fb84c328"
import script from "./Exhibitions.vue?vue&type=script&lang=js"
export * from "./Exhibitions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports